import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import { useContext, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { fetchPropertySnapshot, fetchUserViewSnapshot } from "../AboveProperty.slice";

const SnapShotItem = (props: any) => {
  const { title, data, subTitle, isPrimary, showBorder } = props;

  return (
    <Box
      sx={
        isPrimary
          ? {
              flex: 1,
              textAlign: "center",
              backgroundColor: tokens.Background.General.LightColor,
              borderRadius: "10px",
              color: tokens.Text.General.Inverse,
              height: "78px"
            }
          : {
              flex: 1,
              textAlign: "center",
              color: tokens.Text.General.Secondary,
              borderRight: showBorder ? `1px solid ${tokens.Border.General.Secondary}` : "none"
            }
      }
    >
      <Typography variant="label">{title}</Typography>
      <Typography showBold variant="h2" sx={{ mb: "-8px", mt: isPrimary ? "-8px" : 0 }}>
        {data}
      </Typography>
      <Typography variant="label">{subTitle}</Typography>
    </Box>
  );
};

const SnapShot = (props: any) => {
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const { propertySnapshot, userSnapshot } = useAppSelector((state) => state.aboveProperty);
  let planSnapshot = propertySnapshot?.PROPERTY_PLAN_SNAPSHOT ? propertySnapshot?.PROPERTY_PLAN_SNAPSHOT[0] : {};
  let actionSnapshot = propertySnapshot?.PROPERTY_CARDS_SNAPSHOT ? propertySnapshot?.PROPERTY_CARDS_SNAPSHOT[0] : {};
  const userPlanSnapshot = userSnapshot?.USER_PROPERTY_PLAN_SNAPSHOT
    ? userSnapshot?.USER_PROPERTY_PLAN_SNAPSHOT[0]
    : {};
  const userActionSnapshot = userSnapshot?.USER_PROPERTY_CARDS_SNAPSHOT
    ? userSnapshot?.USER_PROPERTY_CARDS_SNAPSHOT[0]
    : {};

  if (props?.isUser) {
    planSnapshot = userPlanSnapshot;
    actionSnapshot = userActionSnapshot;
  }

  useEffect(() => {
    if (props?.isUser) {
      dispatch(fetchUserViewSnapshot({ hltId: props?.hltId, innCode: props?.innCode }));
    } else {
      dispatch(fetchPropertySnapshot({ inncode: props?.id }));
    }
  }, [props?.innCode]);

  return (
    <Stack direction={isMobileScreen ? "column" : "row"} spacing={2} sx={{ mt: "32px" }}>
      <Stack sx={{ flex: 1 }}>
        <Typography variant="body1" showBold color={tokens.Text.General.Secondary}>
          Plans
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            mt: "8px",
            backgroundColor: tokens.Background.General.Tertiary,
            height: "90px",
            borderRadius: "12px",
            padding: "6px"
          }}
        >
          <SnapShotItem
            isPrimary
            title="Completed"
            subTitle="Past 90 Days"
            data={planSnapshot?.completedLast90Days || 0}
          />
          <SnapShotItem subTitle="Total Active" showBorder data={planSnapshot?.active || 0} />
          <SnapShotItem subTitle="Overdue" data={planSnapshot?.overdue || 0} />
        </Stack>
      </Stack>
      <Stack sx={{ flex: 1 }}>
        <Typography variant="body1" showBold color={tokens.Text.General.Secondary}>
          Actions
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            mt: "8px",
            backgroundColor: tokens.Background.General.Tertiary,
            height: "90px",
            borderRadius: "12px",
            padding: "6px"
          }}
        >
          <SnapShotItem
            isPrimary
            title="Completed"
            subTitle="Past 90 Days"
            data={actionSnapshot?.completedLast90Days || 0}
          />
          <SnapShotItem subTitle="Total Active" showBorder data={actionSnapshot?.active || 0} />
          <SnapShotItem subTitle="Overdue" data={actionSnapshot?.overdue || 0} />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SnapShot;
